import AddHtml from '../js/class.manDom.js';

class CompareItems{
	constructor(datas){
		this.datas = datas;
	}

	/*showItems(box, array){
		// Show Items in the page
		let html = new AddHtml();
		if( this.datas['length'] > 1){
			this.datas.forEach( (el, idx) => {
				html.addHtml(box, 1, 'html', `<div>${el}</div>`);
			})
		} else {
			html.addHtml(box, 1, 'html', '<b>Is clear!</b>');
		}
	}*/

  showItems(container, arrayProd){
    let itemHtml = [ arrayProd ].map(({ link, image, product, price }, index) => {
      let [, integer, decimal] = price.match(/^(\d+\.?\-?)(\d*)/);
      let testos = this.getParamPhone(product);
      let wid = link.split('?wid=')[1];
      return `<div class="row border-bottom mb-3" data-model="${product}"><div class="col-6 col-sm-4 col-md-3 col-lg-3">
        <img class="img-thumbnail rounded" src="${image}" alt="${product} -${price} - [${index}]" onerror="this.src='uploads/onsearch.jpg';"/>
      </div>
      <div class="col-6 col-sm-2 col-md-2 col-lg-1">
        <!--p class="item-wid m-2">Wid: <small>${wid}</small></p-->
        <!--p class="item-text m-2">${product}</p-->
        <button type="button" class="btn btn-sm m-1">
          <span class="ico ico-color_blue ico-95 item-buy"></span>
        </button>
        <p class="m-2">$<span class="price item-price">${integer}${decimal ? "" : "-"}<span class="cents">${
            decimal ? (decimal + "0").slice(0, 2) : ""
          }</span></span></p>
        <button type="button" class="btn btn-sm m-1">
          <span class="ico ico-color_blue ico-66 item-remLS item-compare" title="${product}"></span>
        </button>
        </div>
        <div class="col-12 col-sm-6 col-md-7 col-lg-8">${testos}</div>
      </div>`;
    }).join("");

    //document.getElementById(container).innerHTML += itemHtml;
    container.innerHTML += itemHtml;
  }

  getParamPhone(title){
	  let name = title.match(/\b\w+ \b/) || '-'; // Xiaomi
	  //let model= title.match(/\b.+\s* \d(?=G)/i) || '-('; // ??? -> Xiaomi Redmi Note 6
	  let model= /^([^G]+)\dGB?\s/.exec(title) || '-'; // ??? -> Xiaomi Redmi Note 6

	  let wifi = title.match(/ \d+(?:G)[^B]/) || '-'; //4G
	  let ram  = title.match(/ \d+GB RAM/) || '-'; // 3GB RAM
	  let size = title.match(/[0-9.]+ inch/) || '-'; // 6.18 inch
	  let smart= title.match(/ \w*(tphone|let)/) || '-'; // Phablet | Smartphone
	  let ver  = title.match(/ \w+ Version/i) || '-'; //
	  //console.log(`${name} | ${model} | ${wifi} | ${ram} | ${size} | ${smart[0]} | ${ver}`);
  	let table = `<p class="small mb-1"><b>name</b>: ${name}</p><p class="small mb-1"><b>model</b>: ${model[1]}</p><p class="small mb-1"><b>wifi</b>: ${wifi}</p><p class="small mb-1"><b>Ram</b>: ${ram}</p><p class="small mb-1"><b>Size</b>: ${size}</p><p class="small mb-1"><b>Form</b>: ${smart[0]}</p><p class="small mb-1"><b>Version</b>: ${ver}</p>`;
  	return table;
  }

}

window.onload = function(){

  (async function() {
  	const products = await fetch("json/data.json").then(response =>
  		response.json()
  	)

		let lsCompare = new LocStore();
		let lsResultCompare = lsCompare.getLS('itemCompare');

		let showCompare = new CompareItems(lsResultCompare);
		productsCompare.innerHTML = '';

		if( lsResultCompare === undefined ) {
			return;
		} else {
			let sortArr = [];
			products.forEach( (el, idx) => {
				lsResultCompare.forEach( (s) => {
					if(el['product'] === s ) {
						if( !sortArr.includes(s) ){ 
							showCompare.showItems(productsCompare, el);
							sortArr.push(s);
						}
					}
				});
			});
		}

		document.addEventListener('click', function(e){
			let target = e.target;
			if(target.classList.contains('item-remLS')){
				let title = target.getAttribute('title');
				lsCompare.remLS('itemCompare', title);
				//console.log('What we have: '+ lsCompare.getLS('itemCompare'));
				target.closest('.row').remove();
			}
			if( target.classList.contains('compare-clean') ){
				lsCompare.delLS('itemCompare');
				productsCompare.innerHTML = '';
			}
		}, false);

  })();

};